// After hangup the recording, the final transcript and the summary arrive over a minute or
// two. The call detail says so (`processing`, `recording_status`) and the pages poll until
// it settles. The server stops reporting `processing` 30 minutes after hangup, so polling
// always ends.
import type { CallDetail, RecordingStatus } from "../api/types";

/** How often a call page refetches while the call is still processing. */
export const PROCESSING_POLL_MS = 4_000;

/** Where the recording stands. Servers without `recording_status` only say whether it exists. */
export function recordingState(
  call: Pick<CallDetail, "recording_available" | "recording_status">,
): RecordingStatus {
  if (call.recording_available) return "available";
  return call.recording_status ?? "none";
}

/** `refetchInterval` for a call detail query: poll while the call is processing. */
export function pollWhileProcessing(query: {
  state: { data?: Pick<CallDetail, "processing"> };
}): number | false {
  return query.state.data?.processing ? PROCESSING_POLL_MS : false;
}
